import { FormattedMessage, useIntl } from 'react-intl';

import { DocumentTextIcon } from '@/components/icons/document-text';
import { SourceUpgradeCard } from '@/components/ui/source-upgrade-card';

export function UpgradeCard() {
  const intl = useIntl();

  const benefits = [
    intl.formatMessage({
      defaultMessage: 'Smart prefill for your posting',
      description:
        'Benefit of job board contracts: contract details are read automatically and used to fill in the channel setup',
    }),
    intl.formatMessage({
      defaultMessage: 'Post in seconds',
      description:
        'Benefit of job board contracts: a newly added job board can be posted to almost immediately',
    }),
    intl.formatMessage({
      defaultMessage: 'The board bills you directly',
      description:
        'Benefit of job board contracts: the rates the employer negotiated directly with a job board are used',
    }),
  ];

  return (
    <SourceUpgradeCard
      icon={<DocumentTextIcon className="text-fx-primary size-8" />}
      title={
        <FormattedMessage
          defaultMessage="Use the contracts you already have"
          description="Headline of the upsell shown to accounts without a Source subscription, on the job board contracts settings tab"
        />
      }
      description={
        <FormattedMessage
          defaultMessage="Add a contract you hold with a board and it shows up as a posting option when you post a job. Your negotiated rate doesn't change, and the board still bills you directly."
          description="Explains what job board contracts do, in the upsell for accounts without a Source subscription"
        />
      }
      benefits={benefits}
    />
  );
}
